import {
    FETCH_AGENT_CERTIFICATIONS_REQUEST,
    FETCH_AGENT_CERTIFICATIONS_SUCCESS,
    FETCH_AGENT_CERTIFICATIONS_FAILURE,
} from "./types";

import {
    fetchAgentCertifications,
} from "services/agentCertificationService";

export const fetchAgentCertificationsRequest = () => ({
    type: FETCH_AGENT_CERTIFICATIONS_REQUEST,
});

export const fetchAgentCertificationsSuccess = (data) => ({
    type: FETCH_AGENT_CERTIFICATIONS_SUCCESS,
    payload: data,
});

export const fetchAgentCertificationsFailure = (error) => ({
    type: FETCH_AGENT_CERTIFICATIONS_FAILURE,
    payload: error,
});

export const fetchAgentCertificationsAction =
    (agentId = null) =>
    async (dispatch) => {
        dispatch(fetchAgentCertificationsRequest());

        const result = await fetchAgentCertifications(
            agentId
        );

        if (result.success) {
            dispatch(
                fetchAgentCertificationsSuccess(
                    result.data
                )
            );

            return {
                success: true,
                data: result.data,
            };
        }

        dispatch(
            fetchAgentCertificationsFailure(
                result.error
            )
        );

        return {
            success: false,
            error: result.error,
        };
    };